/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { PluginSimple } from 'markdown-it';
import type { InputRule } from 'prosemirror-inputrules';
import type { Attrs, Schema } from 'prosemirror-model';
import type { Command, EditorState, Plugin } from 'prosemirror-state';
import type { EditorView } from 'prosemirror-view';
import type {
	Dispatch,
	ExtensionsNames,
	ISecodaEditor,
	SecodaEditorState,
} from '../types';

export type CommandFactory = (
	attrs?: Attrs
) => (state: EditorState, dispatch: Dispatch, view: EditorView) => boolean;

export type ExtensionOptions<T> = { type?: T; schema: Schema };

export const EXTENSIONS_DISABLED_BY_DEFAULT: ExtensionsNames[] = [
	'find-and-replace',
];
export default class Extension<T = never> {
	options: any;

	editor!: ISecodaEditor;

	constructor(options: Record<string, any> = {}) {
		this.options = {
			...this.defaultOptions,
			...options,
		};
	}

	bindEditor(editor: ISecodaEditor) {
		this.editor = editor;
	}

	get editorState(): SecodaEditorState {
		return {
			id: this.editor.options.id,
			singleLineEditor: this.editor.options.singleLineEditor ?? false,
			isTemplate: this.editor.options.template ?? false,
			readOnly: this.editor.options.readOnly ?? false,
			disableExtensions: this.editor.options.disableExtensions ?? [],
			schema: this.editor.schema,
			view: this.editor.view!,
			uploadFile: this.editor.options.uploadFile,
			onFileUploadStart: this.editor.options.onFileUploadStart,
			onFileUploadStop: this.editor.options.onFileUploadStop,
			onShowToast: this.editor.options.onShowToast,
			embeds: this.editor.options.embeds,
			disableResourceLinking:
				this.editor.options.disableResourceLinking ?? false,
		};
	}

	get type() {
		return 'extension';
	}

	get name() {
		return 'embed';
	}

	get plugins(): Plugin[] {
		return [];
	}

	get rulePlugins(): PluginSimple[] {
		return [];
	}

	get defaultOptions() {
		return {};
	}

	get focusAfterExecution(): boolean {
		return true;
	}

	keys(_options: ExtensionOptions<T>): Record<string, Command> {
		return {};
	}

	inputRules(_options: ExtensionOptions<T>): InputRule[] {
		return [];
	}

	commands(
		_options: ExtensionOptions<T>
	): Record<string, CommandFactory> | CommandFactory {
		return {};
	}

	widget(): React.ReactElement | null {
		return null;
	}
}
